import { configureStore } from '@reduxjs/toolkit'

import { filterMetadataReducer } from '@modules/filters/filterMetaSlice'
import { sessionReducer } from '@modules/session/slice'

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    filterMeta: filterMetadataReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
